/**
 * Kanttoning för sidscrollande rader (assets/custom-sections.css, [data-edge-fade]).
 * Visar toningen på den sida där det finns mer att scrolla. Används av produktraderna
 * (sections/featured-collection.liquid, sections/related-products.liquid) och kampanjkorten (sections/promo-cards.liquid).
 */
(function () {
  function setup(wrapper) {
    if (wrapper._edgeFade) return;
    var scroller = wrapper.querySelector('[data-edge-fade-scroller]');
    if (!scroller) {
      // Innehåll som laddas senare (t.ex. produktrekommendationer): vänta tills raden finns
      if (!wrapper._edgeFadeWaiting && 'MutationObserver' in window) {
        wrapper._edgeFadeWaiting = new MutationObserver(function () {
          if (!wrapper.querySelector('[data-edge-fade-scroller]')) return;
          wrapper._edgeFadeWaiting.disconnect();
          setup(wrapper);
        });
        wrapper._edgeFadeWaiting.observe(wrapper, { childList: true, subtree: true });
      }
      return;
    }
    wrapper._edgeFade = true;

    var frame = null;
    function update() {
      frame = null;
      var max = scroller.scrollWidth - scroller.clientWidth;
      var x = Math.abs(scroller.scrollLeft);
      wrapper.classList.toggle('has-more-left', x > 4);
      wrapper.classList.toggle('has-more-right', max - x > 4);
    }

    scroller.addEventListener('scroll', function () { if (!frame) frame = requestAnimationFrame(update); }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(function () { update(); }).observe(scroller);
    else window.addEventListener('resize', update);
    update();
  }

  function init(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-edge-fade]'), setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Temaeditorn: sektioner som läggs till eller laddas om
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
